import {
  PsychologistSearchFiltersData,
  PsychologistSearchFiltersResponse,
} from './PsychologistSearchFiltersMapper.types'

class PsychologistSearchFiltersMapper {
  toDomain(
    persistenceData: PsychologistSearchFiltersResponse,
  ): PsychologistSearchFiltersData {
    return {
      themes: persistenceData?.temas,
      theoreticalApproach: persistenceData?.abordagens,
      ageRange: persistenceData?.faixasEtarias,
      gender: persistenceData?.generos,
    }
  }
}

export default new PsychologistSearchFiltersMapper()
